(function () {
  'use strict';

  // iOS Safari fails to dispatch click on the overlay anchor inside .collection-card
  // because the anchor's only descendant is a visually-hidden 1px span.
  // Mirror the pattern used by Atelier's <product-card> web component:
  // bind a delegated click/touch handler that navigates programmatically.

  function findCardLink(target) {
    var card = target.closest && target.closest('.collection-card');
    if (!card) return null;
    // Don't navigate if the user tapped a real interactive element inside the card
    if (target.closest('a, button, input, select, textarea')) return null;
    var link = card.querySelector('.collection-card__link');
    return link && link.href ? link.href : null;
  }

  // Standard click handler — works on desktop and most mobile devices.
  document.addEventListener('click', function (e) {
    var href = findCardLink(e.target);
    if (href) {
      e.preventDefault();
      window.location.href = href;
    }
  });

  // Touch fallback for iOS Safari: detect a real tap (not a swipe/scroll)
  // and navigate manually. We track touchstart coordinates and only fire on
  // touchend if the finger barely moved.
  var touchStart = null;
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest || !e.target.closest('.collection-card')) {
      touchStart = null;
      return;
    }
    var t = e.touches && e.touches[0];
    if (!t) return;
    touchStart = { x: t.clientX, y: t.clientY, t: Date.now(), target: e.target };
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!touchStart) return;
    var t = e.changedTouches && e.changedTouches[0];
    if (!t) { touchStart = null; return; }
    var dx = Math.abs(t.clientX - touchStart.x);
    var dy = Math.abs(t.clientY - touchStart.y);
    var dt = Date.now() - touchStart.t;
    var isTap = dx < 10 && dy < 10 && dt < 500;
    touchStart = null;
    if (!isTap) return;
    var href = findCardLink(e.target);
    if (href) {
      e.preventDefault();
      window.location.href = href;
    }
  }, { passive: false });
})();
